<template>
  <v-toolbar
    id="core-toolbar"
    color="transparent"
    flat
    height="128"
  >
    <v-toolbar-title class="display-1 font-weight-black d-inline-flex pb-1 px-0 px-md-8 align-center">
      <router-link
        :class="$route.path !== '/' ? 'primary--text' : 'white--text'"
        to="/"
      >
        <v-avatar
          class="mr-4"
          size="50"
          tile
        >
          <v-icon size="50" class="mt-2" :color="$route.path !== '/' ? 'primary' : 'white'">mdi-card-account-details-outline</v-icon>
          <!-- <v-img
            contain
            :src="require(`@/assets/logo${ $route.name !== 'home' ? '-dark' : ''}.png`)"
          /> -->
        </v-avatar>

        <span class="hidden-sm-and-down">
          Billit<span style="position: absolute; top: 74px; left: 124px; font-size: 14px !important;" :class="$route.path !== '/' ? 'grey--text' : 'white--text'" class="overline">Medical</span>
        </span>
      </router-link>
    </v-toolbar-title>

    <v-spacer />

    <v-btn
      :dark="$vuetify.breakpoint.lgAndDown"
      :icon="$vuetify.breakpoint.smAndDown"
      class="mr-3"
      text
      to="/demo"
      x-large
    >
      <span v-if="$vuetify.breakpoint.mdAndUp">
        Demo
      </span>

      <v-icon v-else>mdi-monitor-clean</v-icon>
    </v-btn>

    <v-btn
      :dark="$vuetify.breakpoint.lgAndDown"
      :icon="$vuetify.breakpoint.smAndDown"
      class="mr-3"
      text @click="$vuetify.goTo('#pricing', {easing: 'easeInOutQuad' })"
      x-large
    >
      <span v-if="$vuetify.breakpoint.mdAndUp">
        Pricing
      </span>

      <v-icon v-else>mdi-currency-usd</v-icon>
    </v-btn>

    <v-btn
      :dark="$vuetify.breakpoint.lgAndDown"
      :icon="$vuetify.breakpoint.smAndDown"
      class="mr-3"
      text
      to="/about"
      x-large
    >
      <span v-if="$vuetify.breakpoint.mdAndUp">
        About
      </span>

      <v-icon v-else>mdi-information-variant</v-icon>
    </v-btn>

    <v-btn
      :dark="$vuetify.breakpoint.lgAndDown"
      :icon="$vuetify.breakpoint.smAndDown"
      class="mr-3" x-large
      text @click="$vuetify.goTo(pageHeight, {duration: pageHeight / 2.7, easing: 'easeInOutQuad' })"
    >
      <span v-if="$vuetify.breakpoint.mdAndUp">
        Contact
      </span>

      <v-icon v-else>mdi-mail-outline</v-icon>
    </v-btn>

    <v-spacer v-if="$vuetify.breakpoint.mdAndUp && !$vuetify.breakpoint.xlOnly"></v-spacer>

    <v-hover v-slot:default="{ hover }" open-delay="100">
      <div>
        <v-slide-y-transition appear>
          <!-- hioz todo: -->
          <p v-show="hover" class="ml-5 mb-2 text-center overline grey--text">Built By Hioz</p>
        </v-slide-y-transition>
        <base-btn
          :color="$vuetify.breakpoint.mdAndUp ? 'primary' : 'white'"
          :dark="$vuetify.breakpoint.smAndDown" href="/login"
          :fab="$vuetify.breakpoint.smAndDown"
          :min-height="$vuetify.breakpoint.mdAndUp ? 64 : undefined"
          :min-width="$vuetify.breakpoint.mdAndUp ? 169 : undefined"
          :x-large="$vuetify.breakpoint.mdAndUp"
          class="mx-4 elevation-0" outlined style="border-width: 2.5px;"
        > 
          <span v-if="$vuetify.breakpoint.mdAndUp" class="font-weight-bold">
            Login
          </span>

          <!-- todo: open dialog saying billit only available on dekstop -->
          <v-icon v-else color="white">mdi-transfer-right</v-icon>
        </base-btn>
      </div>
    </v-hover>
  </v-toolbar>
</template>

<script>
export default {
  name: 'CoreToolbar',
  computed: {
    pageHeight() {
      return document.documentElement.scrollHeight
    }
  }
}
</script>

<style lang="sass">
  #core-toolbar
    a
      text-decoration: none
</style>
